import zIndex from '@mui/material/styles/zIndex';

const blackListProps = {
	isExist: true,
	spinnerColor: true,
	spinnerBackGroundColor: true,
	isLoading: true,
	divide: true,
	isStartAdornmentExist: true,
	checkboxSize: true,
	hoverColorIconButton: true,
	withoutMaxWidth: true,
	isHover: true,
	iconSize: true,
	errorTextAbsolute: true,
	backgroundColor: true,
	deleteIconColor: true,
	deleteIconSize: true,
	isTag: true,
	onHandleOption: true,
	hasError: true,
	customColor: true,
	closeBtnShow: true,
	dialogRootStyle: true,
	minWidth: true,
	isHeader: true,
	isFixed: true,
	rowIndex: true,
	noData: true,
	cellWidth: true,
	lastFixedItem: true,
	leftDistance: true,
	isRowCanClick: true,
	imageList: true,
	previewWidth: true,
	previewHeight: true,
	previewBorderRadius: true,
	uploadImgLoading: true,
	isMax: true,
	filterNumber: true,
	subMenu: true,
	zIndex: true,
	isResizing: true,
	isSticky: true,
	column: true,
};

export default blackListProps;
